import WorksRequest from "../ws/WorksRequest";

export const WORKS_RECENTLY_ADDED_UPDATE = 'works-recently-added-update';
export const WORKS_RECENTLY_ADDED_LOADING = 'works-recently-added-loading';
export const WORKS_RECENTLY_ADDED_ERROR = 'works-recently-added-error';


export const getWorks = (search = '') => (dispatch) => {

  new WorksRequest(0, search)
    .onPreExecution(() => {
      dispatch({ type: WORKS_RECENTLY_ADDED_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: WORKS_RECENTLY_ADDED_UPDATE,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: WORKS_RECENTLY_ADDED_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: WORKS_RECENTLY_ADDED_LOADING, payload: false });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/works/actions/workRecentlyAddedActions.js